import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import DateColumn from '../../DataTable/datatable.datecolumn';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import EmailEditDialog from '../../Dialogs/Configuration/EmailEditDialog';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function EmailsTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        const getEmails = async function () {
            let url = `api/v1/email`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getEmails();
    }, [fetchDataAuthenticated, includeDeleted, refresh]);

    const tableColumns = [
        {
            Header: 'Subject',
            accessor: 'subject',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>)
            }
        },
        {
            Header: 'To',
            accessor: 'to',
            filter: 'includesString',
        },
        {
            Header: 'Content Type',
            accessor: 'contentType',
            Filter: SelectFilter,
            filter: 'equals'
        },
        DateColumn({ header: 'Generated At', accessor: 'generatedAtUtc' }),
        DateColumn({ header: 'Last Sent At', accessor: 'sentAtUtc' }),
        {
            Header: 'Send Attempts',
            accessor: 'sendAttempts',
            Filter: SelectFilter,
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    let tableMarkup = loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} initialState={{}} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />;

    return tableMarkup;
}

function EmailConfiguration() {
    return (
        <CommonConfigPage
            title={"Emails"}
            Table={EmailsTable}
            Dialog={EmailEditDialog}
        />
    );
}

export default EmailConfiguration;